import React from "react";

export const WIDGET_MIN_HEIGHT = 650;
export const WIDGET_MAX_HEIGHT = 750;
export const WIDGET_MIN_WIDTH = 375;
export const WIDGET_MAX_WIDTH = 375;

const FramePlaceholder = () => {
  // NOTE: Using style prop for clamp() as Tailwind doesn't directly support it with these values.
  const style = {
    height: `clamp(${WIDGET_MIN_HEIGHT}px, 50vh, ${WIDGET_MAX_HEIGHT}px)`,
    width: `clamp(${WIDGET_MIN_WIDTH}px, 75vw, ${WIDGET_MAX_WIDTH}px)`,
    minHeight: `${WIDGET_MIN_HEIGHT}px`,
    minWidth: `${WIDGET_MIN_WIDTH}px`,
    maxHeight: `${WIDGET_MAX_HEIGHT}px`,
    maxWidth: `${WIDGET_MAX_WIDTH}px`,
  };

  return <div className="" style={style}></div>;
};

export default FramePlaceholder;
